import React, { useState,useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { Button, FormGroup, Input, Spinner } from "reactstrap";
// import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "helpers/validations";
import { Link, useNavigate } from "react-router-dom";
import OtpInput from 'react-otp-input';
import { validatePassword } from "helpers/passwordValidation";
import { VerifyUserOtp, forgetPassword, resetPassword } from "store/actions";
import toastr from "toastr";
export default function FogotPassword() {
  const { authToken, user, settings } = useSelector((state) => state?.Login);
  const history = useNavigate();
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state?.Login);
  const reserLoading = useSelector((state) => state?.Register);

  //console.log(reserLoading, "reserLoading");
  const [Otp, setOtp] = useState("");
  //for resend otp button start
  const [seconds, setSeconds] = useState(120);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(true);

  //for resend otp button end

  const [stepOne, setOneStep] = useState(null);
  const [forgotField, setforgotEmail] = useState({
    email: "",
  });
  const [verifyToken,setverifyToken] = useState("")

  
  const [passwordtype, setPasswordType] = useState("password");
  const [passwordtype2, setPasswordType2] = useState("password");

  const pass =()=>{
    if(passwordtype==="password")
    {
     setPasswordType("text")
     return;
    }
    setPasswordType("password")
  }
  const confirmpass =()=>{
    if(passwordtype2==="password")
    {
     setPasswordType2("text")
     return;
    }
    setPasswordType2("password")
  }

  const [fields, setFields] = useState({
   
    // verify_token:"",
    // email: "",
    password: "",
    cnfPassword: "",
  });

  // const {
  //   email1,
  //   emailError1,
  //   OTP,
  //   OTPError,
    
  // } = otp;


  const {
    // email,
    // emailError,
    password,
    passwordError,
    // verify_token,
    // verify_tokenError,
    // OTP,
    // OTPError,
    cnfPassword,
    cnfPasswordError,
  } = fields;

  const forgetChangeHandler = (e) => {
    e.persist();
    const { value, name } = e.target;
    setforgotEmail((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );
  };

  const getOtp = (e) => {

    e.preventDefault();
    let response = validate(forgotField);
    setforgotEmail((prev) => ({ ...prev, ...response }));
    if(forgotField?.email ===''){
      return toastr.error("Please enter your registered email");
    }
    const ForgetData = {
      email: forgotField?.email,
    };
    const callback = (res) => {
     
      const { message, status } = res;
      console.log('Error',message);
      if (status === "failure") {
        return toastr.error(message);
      } else {
        toastr.success("OTP has been sent successfully");
        startTimer();
        setOneStep("1");
      }
    };
    dispatch(forgetPassword(ForgetData, callback));
  };
 const resendOtp = (e)=>{
  e.preventDefault();
  // let response = validate(forgotField);
  // setforgotEmail((prev) => ({ ...prev, ...response }));
  const ForgetData = {
    email: forgotField?.email,
  };
  const callback = (res) => {
    const { message, status } = res;
    if (status === "failure") {
      toastr.error(message);
    } else {
      toastr.success("OTP has been sent successfully");
      resetTimer();
      setOneStep("1");
    }
  };
  dispatch(forgetPassword(ForgetData, callback));
 }
  // Set Password
  const SingUpHandler = (evt) => {
    evt.persist();
    const { value, name } = evt.target;

    if (name == "cnfPassword") {
      setFields((prev) =>
        (value !== "" || undefined || null) && value == fields.password
          ? { ...prev, [name + "Error"]: false, [name]: value }
          : { ...prev, [name + "Error"]: true, [name]: value }
      );
    } else {
      setFields((prev) =>
        value !== "" || undefined || null
          ? { ...prev, [name + "Error"]: false, [name]: value }
          : { ...prev, [name + "Error"]: true, [name]: value }
      );
    }
  };

  const handleChange = (Otp) =>{
    // console.log("otp",Otp)
    setOtp(Otp);
  } 

  
  const verifyOtp = (e) => {
    e.preventDefault();
    if(Otp.length !== 4 ){
   return toastr.error('Please enter 4 digit code')
    }
   

    const OtpDaTa = {
      email: forgotField?.email,
      OTP:Otp,
    };
    // console.log("OtpDaTa",OtpDaTa)
    
    const callback = (res) => {
      const { message, status } = res;
      
      if(res?.data?.verify_token_forgotpassword !=""){
        setverifyToken(res?.data?.verify_token_forgotpassword);
      }
      
      // console.log("otp verify res",res)
      // console.log("message ",message," status ",status)
      if (status == "failure") {
        toastr.error(message);
      } else {
        toastr.success("OTP has been successfully verified");
        
        setOneStep("2");
      }
    };
    
      dispatch(VerifyUserOtp(OtpDaTa, callback));
  
  };

  // const verifyOtp  = (e) => {
  //   setOneStep("2")
  // }

  const setPassword = (e) => {
    e.preventDefault();
    let response = validate(fields);
    setFields((prev) => ({ ...prev, ...response }));
    const ConfirmPasswordData = {
      email: forgotField?.email,
      verify_token:verifyToken,
      password: fields?.password,
      cnfPassword: fields?.cnfPassword,
    };

    if (!validatePassword(fields?.password)) {
      toastr.error("Password should be a minimum of 6 characters, it must include a lower case, upper case and a special character along with a number.");
     return;
    }
  // console.log("hello ",ConfirmPasswordData)
    if (fields?.password !== fields?.cnfPassword) {
      return toastr.error("Confirm password does not match");
    }

    if (fields?.password?.length <= 5) {
      return toastr.error("Password  Required 6 Characters!!");
    }
    const callback = (res) => {
      const { message, status } = res;
      if (status === "failure") {
        toastr.error(message);
      } else {
        // toastr.success(message);
        history("/success");
      }
    };
    dispatch(resetPassword(ConfirmPasswordData, callback));
  };
//resend otp start
useEffect(() => {
  let timer;

  if (isTimerRunning && seconds > 0) {
    timer = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 1000);
  }

  if (seconds === 0) {
    setIsResendButtonDisabled(false);
    setIsTimerRunning(false);
    clearInterval(timer);
  }

  return () => {
    clearInterval(timer);
  };
}, [isTimerRunning, seconds]);

const startTimer = () => {
  setIsTimerRunning(true);
};

const stopTimer = () => {
  setIsTimerRunning(false);
};

const resetTimer = () => {
  setSeconds(120);
  setIsResendButtonDisabled(true);
  setIsTimerRunning(true);
};
const enableResendButton = () => {
  setIsResendButtonDisabled(false);
};
  return (
    <>
      <section className="container-fluid authMaine">
        <div className="row h-100">
          <Col lg="7" className="authLeft forgotPassword">
            <img
              src="../../images/svg/forgotPassword.svg"
              className="Loginim"
              alt="Login"
            />
          </Col>
          <Col lg="5" className="authRight">
            <div className="loginInner">
            <div className="logobx">
                {/* <button className="btn border-0"><i className="fa-sharp fa-light fa-arrow-left-long"></i> Back</button> */}
                <Link to="/" className="navbar-brand mx-auto py-0">
                {settings?.logo?.link && (
                  <div className="d-flex align-items-center justify-content-start position-relative gap-3">
                    <>
                      {settings?.logo?.link.search(".mp4") !== -1 ? (
                     
                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            // src={"/images/t3.gif"}
                           alt="logo"
                          />
                      ) : (
                        <img
                          alt="logo"
                          className="img-fluid logodesktop"
                          src={settings?.logo?.link || "/images/t3.gif"}
                          // src={"/images/t3.gif"}
                        />
                      )}
                    </>

                    {/* <Link to="/" className="nav-link loginLogo logohead ">
                      Terpnash
                    </Link> */}
                  </div>
                )}
              </Link>
                </div>
                <div className="artist-submission create-nftform text-start mt-4">
                  <h1> {stepOne === null
                      ? "Forgot Password"
                      : stepOne === '1' ? "Verify OTP":"Change Password"}</h1>
                  <p>
                    {stepOne == null
                      ? "Enter your email for the verification process, we will send 4 digit code to your email."
                      : stepOne === '1' ? ("Code has sent to " + forgotField?.email ):"To change your password, enter the details below. "}
                  </p>

               
                  <div className="loigin-tabbing">
                  
                    {
                      stepOne === null ? (
                        <form
                          type="submit"
                          className="form-login"
                          onSubmit={getOtp}
                        >
                          <div className="form-login">
                            <FormGroup className="position-relative ">
                              <Input
                                className="inputwithicon"
                                type="email"
                                name="email"
                                value={forgotField?.email}
                                // invalid={emailError}
                                // required={emailError}
                                onChange={forgetChangeHandler}
                                placeholder="Enter Your Email"
                              />
                              <div className="btn position-absolute border-0 top-0 start-0 bottom-0 my-auto">
                                <i className="fa-sharp fa-regular fa-envelope-open"></i>
                              </div>
                            </FormGroup>
                          </div>

                          <button
                            type={"submit"} 
                            className="btn btn-primary mt-4 w-100"
                          >
                            {loading ? (
                              <div className="spinner text-center">
                              
                                <span className=""> Processing...</span>   <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              </div>
                            ) : (
                              "Send OTP"
                            )}
                          </button>
                        </form>
                      ) : stepOne === '1' ? (
                        <Form  onSubmit={verifyOtp} >
                          <div className="otpBoxMain mt-5">
                            <div className="otpm mb-4">
                            <OtpInput className="otpBox"
                              value={Otp}
                              onChange={handleChange}
                              numInputs={4}
                              isInputNum={true}
                             renderInput={(props) => <input {...props} />}
                            />
                            </div>
                            <div className="text-center">
                            <p className="mb-0"><b>{seconds} seconds</b></p>
                            <button type="button" disabled={isResendButtonDisabled} onClick={resendOtp} className="btn btn-outline-primary mb-3 px-3 mx-auto">Re-send</button>
                            </div>
                            <button type="submit" className="btn btn-primary w-100">
                              {loading ? (
                                <div className="spinner">
                                
                                  <span className=""> Processing...</span>  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                </div>
                              ) : (
                                "Verify"
                              )}
                            </button>
                          </div>
                        </Form>
                        ):(
                        <form
                          type="submit"
                          className="form-login"
                          onSubmit={setPassword}
                        >
                          <div className="form-login">
                            {/* <FormGroup className="position-relative ">
                              <Input
                                type="email"
                                className="inputwithicon"
                                name="email"
                                value={fields?.email}
                                invalid={emailError}
                                required={emailError}
                                onChange={SingUpHandler}
                                placeholder="abc@gmail.com"
                              />
                              <div className="btn position-absolute top-0 start-0 border-0 bottom-0 my-auto inpicon">
                                <i className="fa-sharp fa-regular fa-envelope-open"></i>
                              </div>
                            </FormGroup>

                            <FormGroup className="position-relative ">
                              <Input
                                type="text"
                                className="inputwithicon"
                                name="OTP"
                                value={fields?.OTP}
                                invalid={OTPError}
                                required={OTPError}
                                onChange={SingUpHandler}
                                placeholder="Enter OTP"
                              />
                              <div className="btn position-absolute top-0 start-0 border-0 bottom-0 my-auto inpicon">
                                <i className="fa-regular fa-key-skeleton"></i>
                              </div>
                            </FormGroup> */}

                            <FormGroup className="position-relative ">
                              <Input
                                type={passwordtype}
                                className="inputwithicon pe-5"
                                name="password"
                                maxLength={16}
                                value={fields?.password}
                                invalid={passwordError}
                                required={passwordError}
                                onChange={SingUpHandler}
                                placeholder="Enter New Password"
                              />
                              <div className="btn position-absolute top-0 start-0 bottom-0 my-auto">
                                <i className="fa-regular fa-lock-keyhole"></i>
                              </div>
                              <button type="button" onClick={pass} className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon">
                              {passwordtype === 'password' ? <i className="fa-light fa-eye-slash"></i>: <i className="fa-light fa-eye"></i>}
                              </button>
                            </FormGroup>

                            <FormGroup className="position-relative ">
                              <Input
                                type={passwordtype2}
                                className="inputwithicon pe-5"
                                name="cnfPassword"
                                maxLength={16}
                                value={fields?.cnfPassword}
                                invalid={cnfPasswordError}
                                required={cnfPasswordError}
                                onChange={SingUpHandler}
                                placeholder="Confirm Password"
                              />
                              <div className="btn position-absolute top-0 start-0 bottom-0 my-auto">
                                <i className="fa-regular fa-lock-keyhole"></i>
                              </div>
                              <button type="button" onClick={confirmpass} className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon">
                      {passwordtype2 === 'password' ? <i className="fa-light fa-eye-slash"></i>: <i className="fa-light fa-eye"></i>}
                      </button>
                            </FormGroup>
                          </div>

                          <button type={"submit"} className="btn btn-primary w-100">
                            {loading ? (
                              <div className="spinner">
                               
                                <span className=""> Processing...</span>  <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              </div>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </form>
                      )
                      // ) : (
                      // <form type="submit" className="form-login" onSubmit={VerifyOtp}>
                      //   <div className="form-login">
                      //     <FormGroup>
                      //       <Input
                      //         type="text"
                      //         name="OTP"
                      //         value={OTP}
                      //         invalid={OTPError}
                      //         required={OTPError}
                      //         onChange={forgetChangeHandler}
                      //         placeholder="Enter OTP"
                      //       />
                      //     </FormGroup>
                      //   </div>

                      //   <Button type="submit" className="otp_genrate_btn">
                      //     Verify OTP
                      //   </Button>
                      // </form>
                      // <form type="submit" className="form-login" onSubmit={setPassword}>
                      //   <div className="form-login">
                      //     <FormGroup>
                      //       <Input
                      //         type="email"
                      //         name="email"
                      //         value={email}
                      //         invalid={emailError}
                      //         required={emailError}
                      //         onChange={SingUpHandler}
                      //         placeholder="abc@gmail.com"
                      //       />
                      //     </FormGroup>

                      //     <FormGroup>
                      //       <Input
                      //         type="password"
                      //         name="password"
                      //         value={password}
                      //         invalid={passwordError}
                      //         required={passwordError}
                      //         onChange={SingUpHandler}
                      //         placeholder="Enter New Password"
                      //       />
                      //     </FormGroup>

                      //     <FormGroup>
                      //       <Input
                      //         type="password"
                      //         name="cnfPassword"
                      //         value={cnfPassword}
                      //         invalid={cnfPasswordError}
                      //         required={cnfPasswordError}
                      //         onChange={SingUpHandler}
                      //         placeholder="Confirm Password"
                      //       />
                      //     </FormGroup>
                      //   </div>

                      //   <Button type="submit" className="otp_genrate_btn">
                      //     Create New Password
                      //     {loading && (
                      //       <Spinner
                      //         as="span"
                      //         animation="grow"
                      //         size="sm"
                      //         role="status"
                      //         aria-hidden="true"
                      //       />
                      //     )}
                      //   </Button>
                      // </form>
                      // )
                    }
                  </div>
                </div>
                <div className="creetea-account text-center">
                  <p className="text-light2 fw-medium">
                    <span className="text-new_user "> Back to <Link to="/login"><span className="text-black fw-bold">Login</span></Link></span>
                    </p>
                    </div>
              </div>
            
          </Col>
        </div>
      </section>
      {/* <section className="login-main position-relative" hidden>
        <Container className="position-relative">
          <div className="loign-rightmain">
            <div className="forgot_text_div">
              <h2 className="for_text"> Forgot Password </h2>
            </div>

            <div className="loigin-tabbing">
              {
                stepOne == null ? (
                  <form type="submit" className="form-login" onSubmit={getOtp}>
                    <div className="form-login">
                      <FormGroup>
                        <Input
                          className="send_otp"
                          type="email"
                          name="email"
                          value={forgotField?.email}
                          invalid={emailError}
                          required={emailError}
                          onChange={forgetChangeHandler}
                          placeholder="a@gmail.com"
                        />
                      </FormGroup>
                    </div>

                    <Button type={"submit"} className="otp_genrate_btn">
                      {loading ? (
                        <div className="spinner">
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span className=""> Processing...</span>
                        </div>
                      ) : (
                        " Generate OTP"
                      )}
                    </Button>
                  </form>
                ) : (
                  <form
                    type="submit"
                    className="form-login"
                    onSubmit={setPassword}
                  >
                    <div className="form-login">
                      <FormGroup>
                        <Input
                          type="email"
                          name="email"
                          value={fields?.email}
                          invalid={emailError}
                          required={emailError}
                          onChange={SingUpHandler}
                          placeholder="abc@gmail.com"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Input
                          type="text"
                          name="OTP"
                          value={fields?.OTP}
                          invalid={OTPError}
                          required={OTPError}
                          onChange={SingUpHandler}
                          placeholder="Enter OTP"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Input
                          type="password"
                          name="password"
                          className="pe-5"
                          value={fields?.password}
                          invalid={passwordError}
                          required={passwordError}
                          onChange={SingUpHandler}
                          placeholder="Enter New Password"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Input
                          type="password"
                          name="cnfPassword"
                          className="pe-5"
                          value={fields?.cnfPassword}
                          invalid={cnfPasswordError}
                          required={cnfPasswordError}
                          onChange={SingUpHandler}
                          placeholder="Confirm Password"
                        />
                      </FormGroup>
                    </div>

                    <Button type={"submit"} className="otp_genrate_btn">
                      {loading ? (
                        <div className="spinner">
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span className=""> Processing...</span>
                        </div>
                      ) : (
                        "Create New Password"
                      )}
                    </Button>
                  </form>
                )
                // ) : (
                // <form type="submit" className="form-login" onSubmit={VerifyOtp}>
                //   <div className="form-login">
                //     <FormGroup>
                //       <Input
                //         type="text"
                //         name="OTP"
                //         value={OTP}
                //         invalid={OTPError}
                //         required={OTPError}
                //         onChange={forgetChangeHandler}
                //         placeholder="Enter OTP"
                //       />
                //     </FormGroup>
                //   </div>

                //   <Button type="submit" className="otp_genrate_btn">
                //     Verify OTP
                //   </Button>
                // </form>
                // <form type="submit" className="form-login" onSubmit={setPassword}>
                //   <div className="form-login">
                //     <FormGroup>
                //       <Input
                //         type="email"
                //         name="email"
                //         value={email}
                //         invalid={emailError}
                //         required={emailError}
                //         onChange={SingUpHandler}
                //         placeholder="abc@gmail.com"
                //       />
                //     </FormGroup>

                //     <FormGroup>
                //       <Input
                //         type="password"
                //         name="password"
                //         value={password}
                //         invalid={passwordError}
                //         required={passwordError}
                //         onChange={SingUpHandler}
                //         placeholder="Enter New Password"
                //       />
                //     </FormGroup>

                //     <FormGroup>
                //       <Input
                //         type="password"
                //         name="cnfPassword"
                //         value={cnfPassword}
                //         invalid={cnfPasswordError}
                //         required={cnfPasswordError}
                //         onChange={SingUpHandler}
                //         placeholder="Confirm Password"
                //       />
                //     </FormGroup>
                //   </div>

                //   <Button type="submit" className="otp_genrate_btn">
                //     Create New Password
                //     {loading && (
                //       <Spinner
                //         as="span"
                //         animation="grow"
                //         size="sm"
                //         role="status"
                //         aria-hidden="true"
                //       />
                //     )}
                //   </Button>
                // </form>
                // )
              }
            </div>
          </div>
        </Container>
      </section> */}
    </>
  );
}
